export default "__VITE_ASSET__CqstBWho__"